import React from 'react';

import { Chip } from '@mui/material';
import { convertAccBadgeInfo } from '../../utils/useAccessLevel';

export const AccBadge = ({ acc, typeAcc, convertAccBadgeCallback }) => {
  const converter = convertAccBadgeCallback || convertAccBadgeInfo;

  const { label, color, laColor } = converter(acc, typeAcc);

  return (
    <Chip
      sx={{
        backgroundColor: color,
        color: laColor,
        borderRadius: 0,
        fontWeight: 700,
      }}
      label={label}
    />
  );
};
